// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"copy-modal_listContainer__1imTD","listItem":"copy-modal_listItem__cTrjH"};